import AXIOS from '@/utils/$axios';

// 获取普通图或者全景图列表
export const getAlbumList = payload =>
    AXIOS.post('/space/render/get-list', payload);

// 获取全屋漫游列表
export const getVirtualRoomAlbumList = payload =>
    AXIOS.post('/space/render/get-list3d', payload);

// 编辑普通图或者全景图
export const editAlbum = payload => AXIOS.post('/space/render/edit', payload);

// 删除普通图或者全景图
export const deleteAlbum = payload =>
    AXIOS.post('/space/render/delete', payload);

// 删除全屋漫游
export const deleteVirtualRoom = payload =>
    AXIOS.post('/space/render/delete3d', payload);

// 创建普通图或者全景图3d漫游分享
export const createShare = payload =>
    AXIOS.post('/space/render/create-share', payload);

// 获取普通图或者全景图3d漫游分享
export const getShare = payload =>
    AXIOS.post('/space/render/get-share', payload);

// 获取普通图或者全景图筛选用的筛选项
export const getSelectParamsList = payload =>
    AXIOS.post('/space/render/get-rooms-list', payload);

// 升级或者重新渲染
export const resetRender = payload =>
    AXIOS.post('/space/render/reset', payload);

// 创建热点
export const createHotSpot = payload =>
    AXIOS.post('/space/render/create-hotspots', payload);

// 删除热点

export const deleteHotSpot = payload =>
    AXIOS.post('/space/render/delete-hotspots', payload);

// 编辑热点
export const editHotSpot = payload =>
    AXIOS.post('/space/render/edit-hotspots', payload);

// 获取热点列表
export const getHotSpotList = payload =>
    AXIOS.post('/lws/render/get-hotspots', payload);

// 上传头像
export const uploadFile = data =>
    AXIOS.post('/space/common/file-upload', data, {
        headers: {
            'Content-Type': 'multipart/form-data;charset=UTF-8',
        },
    });

// 获取分享热点信息
export const getShareInfo = payload =>
    AXIOS.post('/lws/render/get-share', payload);

// 获取升级分辨率信息
export const getUpgradeInfo = payload =>
    AXIOS.post('/lws/render/condition', payload);

// 获取全屋漫游分享信息

export const getQueueNum = payload =>
    AXIOS.post('/space/render/get-queue', payload);

// 获取全屋漫游版本信息

export const getVirtualRoomVersion = payload =>
    AXIOS.post('/space/scheme/design/get-detail', payload);

// 获取全屋漫游中全景图坐标点

export const getVirtualRoomCoordinate = payload =>
    AXIOS.post('/space/render/get-list3d-size', payload);

// 创建全屋漫游

export const createVirtualRoom = payload =>
    AXIOS.post('/space/render/create3d', payload);

// 编辑全屋漫游

export const editVirtualRoom = payload =>
    AXIOS.post('/space/render/edit3d', payload);
